import styled, { css } from 'styled-components';
import { ReactComponent as IconFillArrowDownSVG } from '../../../assets/icons/icon-fill-arrow-down.svg';

export const IconFillArrowDown = styled(IconFillArrowDownSVG)<{
  $isAsc: boolean;
}>`
  ${(props) => {
    if (props.$isAsc) {
      return css`
        transform: rotate(180deg);
      `;
    }
    return css``;
  }}
`;

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TableHead = styled.div`
  display: flex;
  width: 100%;
  font-family: 'RobotoR', 'NotoKrR';
  background-color: ${(props) => props.theme.colors.grey100};
  color: ${(props) => props.theme.colors.grey500};
  font-size: 16px;
  @media ${(props) => props.theme.device.$bigscreen} {
    font-size: 16px;
  }
`;

const HeadTitleMixin = css`
  display: flex;
  align-items: center;
  width: 100%;
  padding-left: 24px;
  padding-right: 24px;
  height: 56px;
`;

export const HeadURLTitle = styled.div`
  ${HeadTitleMixin}
  @media ${(props) => props.theme.device.$desktop} {
    width: 30%;
  }
  @media ${(props) => props.theme.device.$bigscreen} {
    width: 549px;
  }
`;

export const HeadGroupTitle = styled.div`
  ${HeadTitleMixin}
  @media ${(props) => props.theme.device.$desktop} {
    width: 15%;
  }
  @media ${(props) => props.theme.device.$bigscreen} {
    width: 227px;
  }
`;

export const HeadPageViewTitle = styled.div`
  ${HeadTitleMixin}
  @media ${(props) => props.theme.device.$desktop} {
    width: 15%;
  }
  @media ${(props) => props.theme.device.$bigscreen} {
    width: 227px;
  }
  cursor: pointer;
`;

export const HeadPageViewTitleText = styled.div`
  margin-right: ${(props) => props.theme.spacing.xs}px;
`;

export const HeadRateTitle = styled.div`
  ${HeadTitleMixin}
  @media ${(props) => props.theme.device.$desktop} {
    width: 40%;
  }
  @media ${(props) => props.theme.device.$bigscreen} {
    width: 549px;
  }
`;

const TableBodyMixin = css`
  font-size: 16px;
  padding-left: 24px;
  padding-right: 24px;
  height: 100%;
`;

export const TableBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TableBodyItem = styled.div`
  display: flex;
  width: 100%;
  height: 186px;
  border-bottom: 1px solid ${(props) => props.theme.colors.grey300};
`;

export const TableBodyURL = styled.div`
  ${TableBodyMixin}
  display: flex;
  align-items: center;
  font-family: 'RobotoR', 'NotoKrR';
  color: ${(props) => props.theme.colors.grey800};
  text-decoration: underline;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  width: 30%;
  @media ${(props) => props.theme.device.$desktop} {
    width: 30%;
  }
  @media ${(props) => props.theme.device.$bigscreen} {
    width: 549px;
  }
`;

export const TableBodyGroup = styled.div`
  font-size: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-family: 'RobotoR', 'NotoKrR';
  color: ${(props) => props.theme.colors.grey700};

  @media ${(props) => props.theme.device.$desktop} {
    width: 15%;
  }
  @media ${(props) => props.theme.device.$bigscreen} {
    width: 227px;
  }
`;

export const TableBodyGroupItem = styled.div`
  padding-left: 24px;
  padding-right: 24px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.colors.grey200};
  &:last-child {
    border-bottom: none;
  }
`;

export const TableBodyPageView = styled.div`
  font-size: 16px;
  height: 100%;
  padding-right: 24px;
  display: flex;
  flex-direction: column;
  font-family: 'RobotoB', 'NotoKrB';

  @media ${(props) => props.theme.device.$desktop} {
    width: 15%;
  }
  @media ${(props) => props.theme.device.$bigscreen} {
    width: 227px;
  }
`;

export const TableBodyPageViewItem = styled.div`
  padding-left: 24px;

  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.colors.grey200};
  &:last-child {
    border-bottom: none;
  }
`;

export const TableBodyRate = styled.div`
  padding-left: 24px;
  padding-right: 24px;
  height: 100%;
  @media ${(props) => props.theme.device.$desktop} {
    width: 40%;
  }
  @media ${(props) => props.theme.device.$bigscreen} {
    width: 549px;
  }
`;

export const DataError = styled.div`
  font-family: 'RobotoR', 'NotoKrR';
  font-size: 14px;
  line-height: 1;
  color: ${(props) => props.theme.colors.grey800};
`;
